// Mock data
import Fetch from "../../../fetch";

const token = () => "Bearer " + localStorage.getItem("token");

export const signIn = async ({ email, password }) => {
  const token = "Basic " + btoa(`${email}:${password}`);
  return await Fetch({ route: "auth", method: "POST", token });
};

export const changePassword = async ({ email, password, newPassword }) => {
  const token = "Basic " + btoa(`${email}:${password}`);
  return await Fetch({
    route: "users",
    method: "PATCH",
    token,
    body: JSON.stringify({ newPassword })
  });
};

export const getUser = async () => {
  return await Fetch({ route: "users/self", method: "GET", token: token() });
};

export const createUser = async ({ values }) => {
  return await Fetch({
    route: "users",
    method: "POST",
    token: token(),
    body: JSON.stringify(values)
  });
};


export const updateCustomer = async ({ id, values }) => {
  return await Fetch({
    route: "users/type/" + id,
    method: "PUT",
    token: token(),
    body: JSON.stringify(values)
  });
};

export const update = async ({ values }) => {
  return await Fetch({
    route: "users/self",
    method: "PUT",
    token: token(),
    body: JSON.stringify(values)
  });
};

export const block = async ({ id, values }) => {
  return await Fetch({
    route: "users/block/" + id,
    method: "PATCH",
    token: token(),
    body: JSON.stringify(values)
  });
};

export const getUsers = async params => {
  const route = generateUrl(params, "users");
  return await Fetch({ route, token: token(), method: "GET" });
};

export const creditLog = async id => {
  return await Fetch({
    route: "users/credit/" + id,
    token: token(),
    method: "GET"
  });
};

function generateUrl(params, baseUrl) {
  const ret = [];
  for (let key in params) {
    if (params[key] !== "") {
      ret.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
    }
  }
  const paramString = ret.join("&");
  return paramString ? baseUrl + "?" + paramString : baseUrl;
}
